import { render, staticRenderFns } from "./BankBuildingMain.vue?vue&type=template&id=1e064e1a&"
import script from "./BankBuildingMain.vue?vue&type=script&lang=js&"
export * from "./BankBuildingMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports